import React from 'react';
import Form, { Radio, TextField, Actions, Round, Services, Repeatable, DateTime as DateTimeField, Tags } from '../../Components/Form';
import { useModal } from '../../Components/Modal';
import Accordion, {Panel} from '../../Components/Containers/Accordion';
import DateTime from '../../Components/Formatting/DateTime';

const SearchForm = ({data, updateSearch, submitRef, submitLabel = 'Search', clear, cancel}) => {
    const {closeModal} = useModal();

    const handleSubmit = async (data) => {
        if (data.roundId === 'no-round') {
            data.roundId = '';
        }
        if (data.hasJobsScheduledOnDates) {
            data.hasJobsScheduledOnDates = data.hasJobsScheduledOnDates.map(d => d.date);
        }
        await updateSearch(data);
        closeModal();
    }

    const clearSearch = () => {
        updateSearch({});
        closeModal();
    }

    let cancelOptions = null;
    if (clear) {
        cancelOptions = {label: 'Clear', onClick: clearSearch};
    } else if (cancel) {
        cancelOptions = {label: 'Cancel', onClick: closeModal};
    }

    const marshalledData = {
        ...data,
        hasJobsScheduledOnDates: data?.hasJobsScheduledOnDates?.map(date => ({date})),
    };

    return <Form onSubmit={handleSubmit} data={marshalledData}>
        <TextField name="search" label="Search" />
        <Accordion showInfoBadges>
            <Panel title="Customer details">
                <Tags name="hasTags" label="tags" showAddTag={false} hideIfNoTags />
                <Radio name="hasUnreadMessages"
                    label="Has unread messages"
                    layout="SmallCards"
                    options={[
                        { value: 'Either', label: 'Either' },
                        { value: false, label: 'No' },
                        { value: true, label: 'Yes' },
                    ]}
                />
                <Radio name="balance"
                    label="Balance"
                    layout="SmallCards"
                    options={[
                        { value: 'Any', label: 'Any' },
                        { value: 'Negative', label: 'Debit' },
                        { value: 'Nil', label: 'Zero' },
                        { value: 'Positive', label: 'Credit' },
                    ]}
                />
                <Radio name="type"
                    label="Type"
                    layout="SmallCards"
                    options={[
                        { value: 'Either', label: 'Either' },
                        { value: 'Individual', label: 'Individual' },
                        { value: 'Business', label: 'Business' },
                    ]}
                />
                <Radio name="hasLocation"
                    label="Has location"
                    layout="SmallCards"
                    options={[
                        { value: 'Either', label: 'Either' },
                        { value: 'true', label: 'Yes' },
                        { value: 'false', label: 'No' },
                    ]}
                />
            </Panel>
            <Panel title="Jobs">
                <Tags name="hasJobsWithTags" label="tags" showAddTag={false} hideIfNoTags />
                <Round name="roundId" label="Has job in round" noRoundSelectedLabel="Any" />
                <Repeatable name="hasJobsScheduledOnDates"
                    label="Has jobs scheduled on dates"
                    noItems={null}
                    addItem="Add date"
                    list={(item, index) => <DateTime date={item.date} hideTime />}
                    form={(item, saveItem, cancel) => <ScheduledDateForm {...{item, saveItem, cancel}} />}
                />
                <Services name="hasActiveJobsWithServices"
                    label="Has active job with services"
                    collapsible
                />
                <Services name="hasNoActiveJobsWithServices"
                    label="Has no active job with services"
                    help="Custom has no active job with the selected services"
                    collapsible
                />
                <Services name="hasInactiveJobsWithServices"
                    label="Has inactive job with services"
                    help="A job that has been cancelled or isn't recurring, for example."
                    collapsible
                />
            </Panel>
        </Accordion>

        <Actions submit={{label: submitLabel, btnRef: submitRef}}
            cancel={cancelOptions}
        />
    </Form>
}

const ScheduledDateForm = ({item, saveItem, cancel}) => {
    return <Form data={item} onSubmit={saveItem}>
        <DateTimeField name="date" label="Date" time={false} />
        <Actions submit={{label: 'Add'}} cancel={{label: 'Cancel', onClick: cancel}} />
    </Form>
}

export default SearchForm;
